import { compose } from 'redux';
import { connect } from 'react-redux';
import SpellingView from '../../SpellingView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import { SPELLING } from '../../../constants/measure';
import selectors from '../../../rootSelectors';
import { QUESTIONS } from '../../../constants/assessmentItemType';
import { onNextQuestionButtonClick } from './SpellingQuestionsActions';
import {
    resetSelectedMultiChoiceIndexes,
    resetQuestionsAndTimeTrackingState,
} from '../../../common/questions/questionsActions';
import {
    activateNextButton,
    deactivateNextButton,
    unmountScreen,
    blockScreen,
    unblockScreen,
} from '../../../common/screen/screenActions';
import { narrateReset, narrateStart, stopAudio } from '../../../common/audio/audioActions';
import { SPELLING_AUDIO_INSTRUCTIONS } from '../../spellingConstants';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { fetchSpellingContent, selectPossibleResponses } from '../../spellingActions';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';
import { startQuestionTimeTracking } from '../../../common/timeTracking/timeTrackingActions';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        pageLayout: SPELLING.ASSESSMENT,
        isDataFetched: selectors.getIsSpellingDataFetched(state),
        stimulus: selectors.getSpellingStimulus(state, QUESTIONS, questionIndex - 1),
        selectedResponses: selectors.getMultiChoiceResponses(state),
        questionIndex,
        isPointerVisible: selectors.getIsPointerVisible(state),
        isReadyToNarrate: selectors.getIsReadyToNarrate(state),
        currentLanguage: selectors.getCurrentLanguage(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    const questionIndex = getQuestionIndex(ownProps.match.params);

    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchSpellingContent());
        },
        narrateScreen: async stimulusAudio => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
            dispatch(narrateReset());
            dispatch(unblockScreen());
            dispatch(startQuestionTimeTracking());
        },
        onNext: () => {
            dispatch(onNextQuestionButtonClick(questionIndex));
        },
        resetSelectedResponses: () => {
            dispatch(resetSelectedMultiChoiceIndexes());
            dispatch(deactivateNextButton());
        },
        selectResponse: index => {
            dispatch(selectPossibleResponses(index));
            dispatch(activateNextButton());
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(resetSelectedMultiChoiceIndexes());
            dispatch(unmountScreen());
            dispatch(deactivateNextButton());
        },
    };
};

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            SPELLING_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)].replayInstruction,
    };
};

const SpellingQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(SpellingView);

export default SpellingQuestionsContainer;
